"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ShieldWarning = function (_a) {
    var fill = _a.fill, props = __rest(_a, ["fill"]);
    return (React.createElement("svg", __assign({ fill: "none", viewBox: "0 0 24 24", width: "1em", height: "1em" }, props),
        React.createElement("path", { d: "M11 14V6h2v8h-2zm1 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z", fill: fill || 'currentColor' }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.486 1.143a1 1 0 0 1 1.028 0l2.959 1.775a15 15 0 0 0 4.08 1.69l1.69.422A1 1 0 0 1 22 6v3.606a15.52 15.52 0 0 1-2.605 8.605 10.07 10.07 0 0 1-4.64 3.764l-2.384.953a1 1 0 0 1-.742 0l-2.385-.953a10.07 10.07 0 0 1-4.639-3.764A15.512 15.512 0 0 1 2 9.606V6a1 1 0 0 1 .757-.97l1.69-.423a15 15 0 0 0 4.08-1.69l2.959-1.774zM12 3.166 9.556 4.633a17 17 0 0 1-4.623 1.915L4 6.78v2.825c0 2.668.79 5.276 2.27 7.495a8.07 8.07 0 0 0 3.717 3.017l2.013.805 2.013-.805a8.07 8.07 0 0 0 3.718-3.017A13.512 13.512 0 0 0 20 9.606V6.781l-.933-.233a17 17 0 0 1-4.623-1.915L12 3.166z", fill: fill || 'currentColor' })));
};
exports.default = ShieldWarning;
